import type { ControllerExecutionSuccessResult, ControllerQueryParameters } from '@carlito/ddd';
import type { GetHotelConfigurationController } from '@carlito/hotel-apis';
import { apiRequest } from './api';

export type GetHotelConfigurationParams =
  ControllerQueryParameters<GetHotelConfigurationController>;
export type GetHotelConfigurationResponse =
  ControllerExecutionSuccessResult<GetHotelConfigurationController>;

export async function getHotelConfiguration(params: GetHotelConfigurationParams) {
  const result = await apiRequest<GetHotelConfigurationController>('/hotel/configuration', {
    queryParameters: params,
    method: 'GET',
  });

  return result;
}
